import angular from 'angular'
import { assign } from 'lodash-es'

const DEFAULT_LOCALE = 'en'
const SHORT_TIME_OPTIONS = { year: 'numeric', month: 'numeric', day: 'numeric' }
const LONG_TIME_OPTIONS = assign({ hour: 'numeric', minute: 'numeric' }, SHORT_TIME_OPTIONS)
const TIME_DISTANCE_OPTIONS = { numeric: 'auto' }

angular
  .module('ggs.locale')
  .factory('localeDateInternal', localeDateInternalProvider)

function localeDateInternalProvider() {
  let longTimeFormatter = null
  let shortTimeFormatter = null
  let timeDistanceFormatter = null

  return {
    fromTime,
    longDateTime,
    shortDateTime,
    changeLocale
  }

  function fromTime(toDate, fromDate) {
    const ms = fromDate - toDate
    const sec = Math.round(ms/1000)
    const min = Math.round(sec/60)
    const hrs = Math.round(min/60)
    const day = Math.round(hrs/24)
    const mth = Math.round(day/30)
    const yrs = Math.round(day/365)

    if (yrs !== 0) {
      return timeDistanceFormatter.format(yrs, 'year')
    } else if (mth !== 0) {
      return timeDistanceFormatter.format(mth, 'month')
    } else if (day !== 0) {
      return timeDistanceFormatter.format(day, 'day')
    } else if (hrs !== 0) {
      return timeDistanceFormatter.format(hrs, 'hour')
    } else if (min !== 0) {
      return timeDistanceFormatter.format(min, 'minute')
    } else {
      return timeDistanceFormatter.format(sec, 'second')
    }
  }

  function longDateTime(date) {
    return longTimeFormatter.format(date)
  }

  function shortDateTime(date) {
    return shortTimeFormatter.format(date)
  }

  function changeLocale(appLocale, browserLocale) {
    const intlLocale = appLocale === DEFAULT_LOCALE ? browserLocale : appLocale
    longTimeFormatter = new Intl.DateTimeFormat(intlLocale, LONG_TIME_OPTIONS)
    shortTimeFormatter = new Intl.DateTimeFormat(intlLocale, SHORT_TIME_OPTIONS)
    timeDistanceFormatter = new Intl.RelativeTimeFormat(intlLocale, TIME_DISTANCE_OPTIONS)
  }
}
